import classes from './CtaContentImageBlock.module.scss';
import Markdown from 'markdown-to-jsx';
import Image from 'next/image';
import Button from '../../atoms/button/Button';

export default function CtaContentImageBlock(props) {
    /**
     * Component expects props at object key 0
     */
    if (!props[0]) return null;
    const {
        0: ComponentCardHeroCta,
        1: ComponentContentSiteImage,
        2: ComponentListCtaList,
        3: ComponentFieldSiteBackgroundImage,
        4: ComponentContentCardTheme
    } = props;

    const imageData = ComponentContentSiteImage.image.data.attributes;
    const imagePosition = ComponentContentCardTheme.image_position;
    const customClass = ComponentContentCardTheme.custom_class;
    const extenderClass = 'inlineCta';

    return (
        <section
            className={`${classes.oSection} ${classes[imagePosition]} ${classes[customClass]}}`}
        >
            <div className={`${classes.oContainer} container`}>
                <div className={`${classes.oRow} row`}>
                    <div className={`${classes.oColText} col-md-6`}>
                        <p className={`${classes.aPreText} fnt21`}>
                            {ComponentCardHeroCta.hero_content.sub_title}
                        </p>
                        <h1 className={`${classes.aTitle} fnt50`}>
                            {ComponentCardHeroCta.hero_content.title}
                        </h1>
                        <Markdown className={`${classes.aCopyText} fnt13f`}>
                            {ComponentCardHeroCta.hero_content.description}
                        </Markdown>
                        <div className={`${classes.mCtaRegion}`}>
                            <h5 className={`${classes.aTitle} fnt16`}>
                                {ComponentListCtaList.title}
                            </h5>
                            <div className={`${classes.mCtaList} mCtaList`}>
                                {ComponentListCtaList.next_steps_ctas.map((cta) => {
                                    return (
                                        <Button
                                            key={cta.id}
                                            url={cta.href}
                                            style={`btnAlt${cta.id}`}
                                            extenderClass={extenderClass}
                                            {...cta}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                    <div className={`${classes.oColImage} col-md-6`}>
                        <figure className={classes.mImage}>
                            <Image
                                src={imageData.url}
                                alt={`Chat Banner`}
                                width={imageData.width}
                                height={imageData.height}
                                className={classes.aImage}
                                aria-hidden="true"
                                layout="responsive"
                                priority="true"
                            />
                        </figure>
                    </div>
                </div>
            </div>
            <div
                className={classes.oBackgroundImage}
                style={{
                    backgroundImage: `url(${ComponentFieldSiteBackgroundImage.background_image.data.attributes.url})`
                }}
            ></div>
        </section>
    );
}
